<script lang="ts">
    import HeroBanner from "../components/HeroBanner.svelte";
    import AboutContent from "../components/AboutContent.svelte";
    import EducationContent from "../components/EducationContent.svelte";
    import HowIWorkContent from "../components/HowIWorkContent.svelte";
    import PricingContent from "../components/PricingContent.svelte";
    import ContactContent from "../components/ContactContent.svelte";
    import { onMount } from 'svelte';

    // Animation state
    let coponukamVisible = false;
    let akopracujemVisible = false;
    let cennikVisible = false;
    let vzdelanieVisible = false;
    let kontaktVisible = false;

    onMount(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px -100px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const id = entry.target.id;
                    if (id === 'coponukam') coponukamVisible = true;
                    if (id === 'akopracujem') akopracujemVisible = true;
                    if (id === 'cennik') cennikVisible = true;
                    if (id === 'vzdelanie') vzdelanieVisible = true;
                    if (id === 'kontakt') kontaktVisible = true;
                }
            });
        }, observerOptions);

        // Observe sections
        const coponukamSection = document.getElementById('coponukam');
        const akopracujemSection = document.getElementById('akopracujem');
        const cennikSection = document.getElementById('cennik');
        const vzdelanieSection = document.getElementById('vzdelanie');
        const kontaktSection = document.getElementById('kontakt');

        if (coponukamSection) observer.observe(coponukamSection);
        if (akopracujemSection) observer.observe(akopracujemSection);
        if (cennikSection) observer.observe(cennikSection);
        if (vzdelanieSection) observer.observe(vzdelanieSection);
        if (kontaktSection) observer.observe(kontaktSection);

        return () => {
            observer.disconnect();
        };
    });

</script>

<HeroBanner />

<svelte:head>
    <title>Psychológ Košice | Andrea Vrábeľová - Individuálne konzultácie</title>
    <meta name="description" content="Psychologička Andrea Vrábeľová v Košiciach. Individuálna psychoterapia a terapia pod odbornou supervíziou. Geštalt terapia, pomoc pri úzkosti, depresii, vzťahových problémoch. Konzultácie aj v maďarskom jazyku." />
    <meta name="keywords" content="psychológ Košice, psychologické poradenstvo, individuálne konzultácie, úzkosť, depresia, vzťahové problémy, Andrea Vrábeľová, psychoterapia Košice, terapia Košice, Geštalt terapia, psychoterapeut Košice, terapeutické sedenia, individuálna psychoterapia, pszichológus Kassa, magyar nyelvű konzultáció, egyéni konzultáció Kassa, pszichológiai tanácsadás, pszichoterápia Kassa, terápia Kassa" />

    <!-- Open Graph / Facebook -->
    <meta property="og:type" content="website" />
    <meta property="og:title" content="Psychológ Košice | Andrea Vrábeľová - Individuálne konzultácie" />
    <meta property="og:description" content="Psychologička Andrea Vrábeľová v Košiciach. Individuálne konzultácie pod odbornou terapeutickou supervíziou. Pomoc pri úzkosti, depresii a vzťahových problémoch." />
    <meta property="og:locale" content="sk_SK" />
    <meta property="og:locale:alternate" content="hu_HU" />

    <!-- Twitter -->
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Psychológ Košice | Andrea Vrábeľová" />
    <meta name="twitter:description" content="Psychologička Andrea Vrábeľová v Košiciach. Individuálne konzultácie pod odbornou terapeutickou supervíziou. Pomoc pri úzkosti, depresii a vzťahových problémoch." />

    <!-- Geo tags -->
    <meta name="geo.region" content="SK-KI" />
    <meta name="geo.placename" content="Košice" />
</svelte:head>

<main class="min-h-screen scroll-smooth">
    <section id="coponukam" class="animate-section {coponukamVisible ? 'visible' : ''}">
        <AboutContent />
    </section>
    <section id="akopracujem" class="animate-section {akopracujemVisible ? 'visible' : ''}">
        <HowIWorkContent />
    </section>
    <section id="cennik" class="animate-section {cennikVisible ? 'visible' : ''}">
        <PricingContent />
    </section>
    <section id="vzdelanie" class="animate-section {vzdelanieVisible ? 'visible' : ''}">
        <EducationContent />
    </section>
    <section id="kontakt" class="animate-section {kontaktVisible ? 'visible' : ''}">
        <ContactContent />
    </section>
</main>

<style>
    .animate-section {
        opacity: 0;
        transform: translateY(50px);
        transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
        scroll-margin-top: 115px;
    }

    .animate-section.visible {
        opacity: 1;
        transform: translateY(0);
    }
</style>
